import { render, staticRenderFns } from "./SlideDeck.vue?vue&type=template&id=608aeb30&"
import script from "./SlideDeck.vue?vue&type=script&lang=js&"
export * from "./SlideDeck.vue?vue&type=script&lang=js&"
import style0 from "./SlideDeck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports